import contentstack from 'contentstack/react-native';
import {useEffect, useState} from 'react';

export const PcBangContentStack = contentstack.Stack(
  CONTENTSTACK_API_KEY,
  CONTENTSTACK_DELIVERY_TOKEN,
  CONTENTSTACK_ENV
);

export const useContentStack = (contentType, orderBy = '') => {
  const [entries, setEntries] = useState('fetching');

  useEffect(() => {
    PcBangContentStack.ContentType(contentType)
      .Query()
      .ascending(orderBy)
      .toJSON()
      .find()
      .then(
        result => {
          setEntries(result[0]);
        },
        () => {
          alert('관리자에 문의해주세요');
        }
      );
  }, []);

  return entries;
};
